export default "__VITE_ASSET__CtA7RpJN__"